import React, {useState, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTags, setTags } from '../redux/plan'
import { useToken } from "../redux/auth";
import { saveTag } from "../modules/db";
import { theme } from "../theme";

const tagMap = {
  AR:"Audit Requirements",
  LOC:"Locations",
  DOC:"Document type",
  PR:"Process",
  ING:"Ingredients",
  PRS:"Process Step", 
  EQU:"Equipment",
  PAC:"Packaging material type"
}

const filter = createFilterOptions();

export default function NewTagDialog({isOpen, onClose, docTags, ...props}) {
  const token = useToken()
  const {colors} = theme
  const tags = useTags()
  const [state, setState] = useState({
    tag:'',
    newTag:'',
    displayedTags: tags,
  })

  const createNewTag = (newTag) => {
    const cleanNewTag = newTag.replace(/\s/g,'')
    setState({
      ...state,
      newTag: newTag,
    });
    const newTags = tags[state.tag]
    if( !newTags.some( elem => elem.replace(/\s/g,'').toLowerCase() === cleanNewTag.toLowerCase() ) ){
      if (window.confirm("Do you really want to add this tag?")) {
        newTags.push(newTag)
        setTags({...tags,[state.tag]:newTags})
        saveTag(token, {
          category: state.tag,
          tag: newTag,
        })
        alert(`Tag created successfully. You may close this dialog and use the new tag on this form.`)
      }
    }
    else {
      alert(`The proposed tag already exits, please enter a new one and try again`)
    }
  }
  

  useEffect( () => {
    if(docTags){
      const {EQU, PAC, DOC, ING, PRS, ...allowedTags} = tags
      setState({...state, displayedTags: allowedTags})
    }
  }, [])
  
  return (
    <Dialog
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Manage Tags"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Tag Type
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            style={{width:'100%', marginBottom: 25}}
            value={state.tag}
            onChange={ e => setState({...state, tag:e.target.value})}
          >
            {Object.keys(state.displayedTags).map( tag => <MenuItem value={tag}>{tagMap[tag]}</MenuItem>)}
          </Select>
          {
            state.tag !== '' &&
            <Autocomplete
              value={state.newTag}
              onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                  setState({
                    ...state,
                    newTag: newValue,
                  });
                } else if (newValue && newValue.inputValue) {
                  // Create a new value from the user input
                  createNewTag(newValue.inputValue)
                  
                } else {
                  setState({...state, newValue});
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                // Suggest the creation of a new value
                if (params.inputValue !== '') {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Add "${params.inputValue}"`,
                  });
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={tags[state.tag]}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }
                // Regular option
                return option;
              }}
              renderOption={(option) => typeof option === 'string' ? option : option.title }
              style={{ width: 300 }}
              freeSolo
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label="Write a new tag" 
                  variant="outlined"
                  onKeyDown={e => {
                    if (e.keyCode === 13 && e.target.value) {
                      createNewTag(e.target.value)
                    }
                  }}
                />
              )}
            />
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          variant="contained"
          size="large"
          style={{ 
          backgroundColor: colors.secondary,
          color: colors.light,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}